import {
  ActivityChangeOptions,
  ActivityItem,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';
import {
  ISSUE_ACTIVITY_TYPES,
  createIssueUpdatesChangeExtension,
} from '@spotify/plugin-confidence-issues-react';

import { isIssueActivityType } from './issueActivityUtils';

const ISSUE_STATE_LABELS: Record<string, string> = {
  OPEN: 'Open',
  IN_PROGRESS: 'In progress',
  CLOSED: 'Closed',
};

const getStateLabel = (value: unknown): string => {
  if (typeof value === 'string') {
    return ISSUE_STATE_LABELS[value] ?? value;
  }

  return 'Unknown';
};

const getActionTitle = (newState: unknown): string => {
  if (newState === 'CLOSED') {
    return 'Issue closed';
  }

  if (newState === 'IN_PROGRESS') {
    return 'Issue started';
  }

  if (newState === 'OPEN') {
    return 'Issue reopened';
  }

  return 'Updated state';
};

const IssueStateChangeRender = ({ change }: ActivityChangeOptions) => (
  <ActivityItem.Section label="State">
    <ActivityTagItem
      oldValue={getStateLabel(change.oldValue)}
      newValue={getStateLabel(change.newValue)}
    />
  </ActivityItem.Section>
);

export const ISSUE_STATE_CHANGE_EXTENSION = createIssueUpdatesChangeExtension({
  id: 'issue-state-change',
  priority: 10,
  predicate: options =>
    isIssueActivityType(options.activity, ISSUE_ACTIVITY_TYPES.stateChanged) &&
    options.change.fieldPath === '/state',
  title: change => getActionTitle(change.newValue),
  render: IssueStateChangeRender,
  values: change => ({
    oldValue: { state: change.oldValue },
    newValue: { state: change.newValue },
  }),
});
